module.exports = __webpack_public_path__ + "47dca96f584e94db3d95ca7c7de06140.pdf";